import { loadStripe } from '@stripe/stripe-js'

export async function handleFormSubmission (event) {
  event.preventDefault()
  const checkoutFormSubmitElement = document.querySelector('.js-checkout-submit')

  if (checkoutFormSubmitElement) {
    checkoutFormSubmitElement.disabled = true

    const form = new FormData(event.target)

    const data = {
      productSku: form.get('product_sku'),
      deliverySku: form.get('delivery_sku'),
      quantity: form.get('quantity'),
    }

    try {
      fbq('track', 'Checkout', { quantity: data.quantity });
    } catch (error) {
      console.log("FB pixel is not initialized");  
    }
    
    const response = await fetch('/.netlify/functions/create-checkout', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    }).then((res) => res.json())

    const stripe = await loadStripe(response.publishableKey);
    const { error } = await stripe.redirectToCheckout({
      sessionId: response.sessionId,
    })

    if (error) {
      console.error(error)
    }

    checkoutFormSubmitElement.disabled = false
  }
}
